import moment from 'moment-timezone'
moment.locale(sessionStorage.getItem('locale') || 'pt-br')
export default moment
